"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractTableController = (function () {
    function AbstractTableController() {
    }
    Object.defineProperty(AbstractTableController.prototype, "rows", {
        get: function () {
            throw new Error("not implemented");
        },
        set: function (rows) {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "presetRow", {
        get: function () {
            throw new Error("not implemented");
        },
        set: function (row) {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "totalRow", {
        get: function () {
            throw new Error("not implemented");
        },
        set: function (row) {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "rowChangedEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "rowDeleteEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "rowAddEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "presetChangedEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "tableClearedEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "invalidateEvaluationEvent", {
        get: function () {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "activeMediumTypes", {
        set: function (types) {
            throw new Error("not implemented");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "planName", {
        get: function () {
            throw new Error("Not implemented!");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "currentColumnSet", {
        get: function () {
            throw new Error("Not implemented!");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "allColumns", {
        get: function () {
            throw new Error("Not implemented!");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "posterData", {
        set: function (data) {
            throw new Error("Not implemented!");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractTableController.prototype, "limitValue", {
        get: function () {
            throw new Error("Not implemented!");
        },
        set: function (value) {
            throw new Error("Not implemented!");
        },
        enumerable: true,
        configurable: true
    });
    return AbstractTableController;
}());
exports.AbstractTableController = AbstractTableController;
//# sourceMappingURL=AbstractTableController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/AbstractTableController.js
// module id = 14
// module chunks = 0